<template>
  <v-card class="mt-3 pa-4">
    <h3>Probes</h3>

    <v-row class="px-3" align="center">
      <h4>Add new</h4>
      <v-combobox v-model="newUserProbe.probe_id" label="Probe" :items="probes" item-text="alias" item-value="id"
                  class="ml-3"/>
      <v-menu
          v-model="dateFromMenuVisible"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              label="Start date"
              :value="newUserProbe.date_from"
              prepend-icon="mdi-calendar"
              readonly
              class="ml-3"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            first-day-of-week="1"
            v-model="newUserProbe.date_from"
            @input="dateFromMenuVisible = false"
        ></v-date-picker>
      </v-menu>
      <v-menu
          v-model="dateToMenuVisible"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              label="End date"
              :value="newUserProbe.date_to"
              prepend-icon="mdi-calendar"
              readonly
              class="ml-3"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            first-day-of-week="1"
            v-model="newUserProbe.date_to"
            @input="dateToMenuVisible = false"
        ></v-date-picker>
      </v-menu>
      <v-btn @click="handleAddNewUserProbe" class="ml-3" small color="primary">Add</v-btn>
    </v-row>

    <v-simple-table v-if="activeUser">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            #
          </th>
          <th class="text-left">
            Alias
          </th>
          <th class="text-left">
            From
          </th>
          <th class="text-left">
            To
          </th>
          <th class="text-left">
            Default
          </th>
          <th width="5%" class="text-right"/>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(probe, idx) in activeUser.probes"
            :key="`probe_${probe.id}`"
        >
          <td>{{ idx + 1 }}</td>
          <td>{{ probe.probe_info.alias }}</td>
          <td>{{ probe.start_date | formatDate }}</td>
          <td>{{ probe.end_date | formatDate }}</td>
          <td>
            <v-icon color="green" v-if="probe.is_default">mdi-check</v-icon>
          </td>
          <td class="text-right">
            <v-btn @click="setEditProbe(probe)" icon small color="primary">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog width="600" v-model="editModalVisible" @close="editModalVisible = false" v-if="editProbe">
      <v-card class="pa-3">
        <v-card-title>{{ editProbe.probe_info.alias }}</v-card-title>
        <v-menu
            v-model="dateFromEditMenuVisible"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                label="Start date"
                :value="editProbe.start_date"
                prepend-icon="mdi-calendar"
                readonly
                class="ml-3"
                v-bind="attrs"
                v-on="on"
                hide-details
            ></v-text-field>
          </template>
          <v-date-picker
              first-day-of-week="1"
              v-model="editProbe.start_date"
              @input="dateFromEditMenuVisible = false"
          ></v-date-picker>
        </v-menu>
        <v-menu
            v-model="dateToEditMenuVisible"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                label="End date"
                :value="editProbe.end_date"
                prepend-icon="mdi-calendar"
                readonly
                class="ml-3"
                v-bind="attrs"
                v-on="on"
                hide-details
            ></v-text-field>
          </template>
          <v-date-picker
              first-day-of-week="1"
              v-model="editProbe.end_date"
              @input="dateToEditMenuVisible = false"
          ></v-date-picker>
        </v-menu>
        <v-checkbox
            class="ml-3"
            v-model="editProbe.is_default"
            label="Is default"
        ></v-checkbox>
        <v-row>
          <v-btn @click="handleDeleteProbeClick" dark color="red" class="ml-5 mb-4">Delete</v-btn>
          <v-spacer/>
          <v-btn @click="editModalVisible = false" class="mr-4 mb-2">Cancel</v-btn>
          <v-btn @click="handleSubmitEditProbeClick" color="primary" class="mr-4 mb-2">Save</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-card>

</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "UserProbes",
  data() {
    return {
      editModalVisible: false,
      dateFromMenuVisible: false,
      dateToMenuVisible: false,
      dateFromEditMenuVisible: false,
      dateToEditMenuVisible: false,
      editProbe: null
    }
  },
  computed: {
    ...mapState('user', ['activeUser', 'newUserProbe']),
    ...mapState('probe', ['probes']),
  },
  methods: {
    ...mapActions('user', ['addNewUserProbe', 'editUserProbe', 'deleteUserProbe']),
    setEditProbe(probe) {
      this.editProbe = {...probe}
      this.editModalVisible = true
    },
    async handleSubmitEditProbeClick() {
      const resp = await this.editUserProbe(this.editProbe)

      if (resp.success === 1) {
        this.editModalVisible = false
        this.editProbe = null
      }
    },
    async handleDeleteProbeClick() {
      if (confirm('Are you sure?')) {
        const resp = await this.deleteUserProbe(this.editProbe)
        if (resp.success === 1) {
          this.editModalVisible = false
          this.editProbe = null
        }
      }
    },
    async handleAddNewUserProbe() {
      if (!this.newUserProbe.probe_id) {
        alert('Please select a probe from dropdown!')
        return
      }
      await this.addNewUserProbe()
    }
  }
}
</script>

<style scoped>

</style>